import { localStore, STORE_KEYS } from "@/storage";
const endpoints = require("@/api/endpoints");
const { v4: uuidv4 } = require("uuid");

const logger = new (require("@/logging").Logger)("store.payment.actions");

function connectToPaymentWebsocket(hybridSocketUrl) {
  // WEBSOCKET START
  let auth_token = localStore.getItem(STORE_KEYS.AUTH_TOKEN);
  let device_id = localStore.getItem(STORE_KEYS.DEVICE_ID);
  let socketUrl = hybridSocketUrl;
  let heartbeat = 5;

  if (heartbeat > 0) {
    return;
  }

  // @ts-ignore
  if (!window.paymentSocketConnection) {
    // @ts-ignore
    window.paymentSocketConnection = new WebSocket(
      socketUrl + "?device=" + device_id + "&auth=" + auth_token
    );
  }
  setInterval(() => {
    // @ts-ignore
    window.paymentSocketConnection.send(
      JSON.stringify({
        id: uuidv4(),
        action: "heartbeat",
        data: { state: "general" },
      })
    );
  }, heartbeat * 1000);
  // WEBSOCKET END
}

/**
 * @template D -- request data type
 * @template R -- response data type
 * @param {EndpointFunction<D, R>} endpoint
 * @param {import("axios").AxiosInstance} axios
 * @param {D} data
 * @param {boolean} [auto_retry=false]
 * @returns {Promise<R>}
 */
function axiosErrorHandlingWrapper(endpoint, axios, data, auto_retry = false) {
  return new Promise((resolve, reject) => {
    endpoint(axios, data).then(
      (response) => {
        // Success or error response from server. (status code in 200<=...<500 range)
        resolve(response.data);
      },
      (error) => {
        // 500 status code or failed request (e.g. network)
        if (
          auto_retry &&
          (error.response == null || error.response.status == null)
        ) {
          // One time recursive auto retry.
          resolve(axiosErrorHandlingWrapper(endpoint, axios, data, false));
        } else {
          console.error("axiosErrorHandlingWrapper retry");
          // Throw the error via wrapper Promise.
          reject(error);
        }
      }
    );
  });
}

export const actions = {
  setIsPromotionPayment({ commit }, payload) {
    commit("setIsPromotionPayment", payload);
  },
  setPromotionReferrer({ commit }, payload) {
    commit("setPromotionReferrer", payload);
  },
  setStripeActivePage({ commit }, payload) {
    commit("setStripeActivePage", payload);
  },
  setSelectedPaymentMethod({ commit }, payload) {
    commit("setSelectedPaymentMethod", payload);
  },
  setStripePaymentSucceeded({ commit }, payload) {
    commit("setStripePaymentSucceeded", payload);
  },
  setSelectedProduct({ commit }, payload) {
    commit("setSelectedProduct", payload);
  },
  setHybridPaymentFlowInformation({ commit }, payload) {
    if (!payload.flow_id) payload["flow_id"] = uuidv4();
    commit("setHybridPaymentFlowInformation", payload);
  },
  setHybridPaymentFlowInformationProps({ commit, state }, payload) {
    const hybridPaymentFlowInformation = {
      ...state.hybridPaymentFlowInformation,
      ...payload,
    };
    commit("setHybridPaymentFlowInformation", hybridPaymentFlowInformation);
  },
  stripePaymentWebsocket({ state }, hybridSocketUrl) {
    return new Promise((resolve) => {
      let a = false;

      if (a) {
        connectToPaymentWebsocket(hybridSocketUrl);

        // @ts-ignore
        window.paymentSocketConnection.onmessage = (event) => {
          // WHEN MESSAGE COME FROM SOCKET
          let socketMessage = JSON.parse(event.data);
          if (socketMessage.data) {
            // PAYMENT SUCCEEDED
            if (socketMessage.type == "stripe_payment_succeeded") {
              return resolve("succeeded");
            }
          }
        };
      }
    });
  },
  stripeDetachPaymentMethod({ state }, paymentMethodId) {
    return new Promise((resolve, reject) => {
      endpoints
        .detach_payment_method(this._vm.$axios, {
          payment_method_id: paymentMethodId,
        })
        .then((detachResponse) => {
          if (detachResponse.data.error) {
            reject(detachResponse.data);
          } else {
            resolve(detachResponse.data);
          }
        });
    });
  },
  createPaymentMethod({ state }, createPaymentMethodData) {
    return new Promise((resolve, reject) => {
      endpoints
        .create_payment_method(this._vm.$axios, createPaymentMethodData)
        .then((createPaymentMethodResponse) => {
          if (
            createPaymentMethodResponse &&
            createPaymentMethodResponse.error
          ) {
            reject(createPaymentMethodResponse.error);
          } else {
            resolve(createPaymentMethodResponse.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  stripePayment({ state }, paymentData) {
    return new Promise((resolve, reject) => {
      endpoints
        .confirm_payment(this._vm.$axios, paymentData)
        .then((payWithMethodResponse) => {
          if (payWithMethodResponse.data.error) {
            reject(payWithMethodResponse.data);
          } else {
            resolve(payWithMethodResponse.data);
          }
        });
    });
  },
  reConfirmPayment({ state }, paymentData) {
    return new Promise((resolve, reject) => {
      endpoints
        .reconfirm_payment(this._vm.$axios, paymentData)
        .then((payWithMethodResponse) => {
          if (payWithMethodResponse.data.error) {
            reject(payWithMethodResponse.data);
          } else {
            resolve(payWithMethodResponse.data);
          }
        });
    });
  },
  stripePaymentMethods({ state }, productId) {
    return new Promise((resolve, reject) => {
      endpoints
        .payment_methods(this._vm.$axios, {
          product_id: productId,
        })
        .then((paymentMethodsResponse) => {
          if (paymentMethodsResponse.data.error) {
            reject(paymentMethodsResponse.data);
          } else {
            resolve(paymentMethodsResponse.data);
          }
        });
    });
  },
  paypalPayment2(_, axios, paymentData) {
    console.log("axios", axios, "paymentData", paymentData);
    return axiosErrorHandlingWrapper(
      endpoints.paypal_payment,
      axios,
      paymentData,
      false
    );
  },
  getPayPalSavedAccounts(_, axios, body) {
    return axiosErrorHandlingWrapper(
      endpoints.paypal_saved_accounts,
      axios,
      body,
      false
    );
  },
  deletePayPalSavedAccount(_, axios, body) {
    return axiosErrorHandlingWrapper(
      endpoints.paypal_delete_saved_account,
      axios,
      body,
      false
    );
  },
  getSavedCards(_, axios, data) {
    return axiosErrorHandlingWrapper(endpoints.saved_cards, axios, data, false);
  },
  deleteSavedCard(_, axios, data) {
    return axiosErrorHandlingWrapper(
      endpoints.delete_saved_card,
      axios,
      data,
      false
    );
  },
};
